import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
var state = {
    companies: [],
    loading: false,
};
export var companies = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
